import React from "react";
import styled from "styled-components";
import "loaders.css/loaders.css";

const BallContainer = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Ball = styled.div`
  background-color: #7266ba !important;
`;

export default () => {
  return (
    <BallContainer className="ball-scale">
      <Ball></Ball>
    </BallContainer>
  );
};



// WEBPACK FOOTER //
// ./src/components/Layout/Loading.jsx